export interface IPointContent {
  label: string;
  content: string[];
}

export type KeyPoint = 'roadTestChecks' | 'exterior' | 'interior' | 'underbody';

const ROAD_TEST_CHECKS = `ccpo.inspectionPointList.roadTestChecks`;
const dataRoadTestChecks: IPointContent[] = [
  {
    label: `${ROAD_TEST_CHECKS}.engineSubtitle`,
    content: [
      `${ROAD_TEST_CHECKS}.engineStartsProperly`,
      `${ROAD_TEST_CHECKS}.engineNoise`,
      `${ROAD_TEST_CHECKS}.engineIdlesProperly`,
      `${ROAD_TEST_CHECKS}.engineAcceleration`,
      `${ROAD_TEST_CHECKS}.belting`,
      `${ROAD_TEST_CHECKS}.engineTransmissionMounting`,
    ],
  },
  {
    label: `${ROAD_TEST_CHECKS}.steeringBrakesSuspensionSubtitle`,
    content: [
      `${ROAD_TEST_CHECKS}.brakePadsThickness`,
      `${ROAD_TEST_CHECKS}.brakePedal`,
      `${ROAD_TEST_CHECKS}.brakeLinesHosesFittings`,
      `${ROAD_TEST_CHECKS}.suspensionAndShockAbsorber`,
      `${ROAD_TEST_CHECKS}.steeringOperation`,
      `${ROAD_TEST_CHECKS}.undercarriageNoises`,
      `${ROAD_TEST_CHECKS}.gearBox`,
    ],
  },
  {
    label: `${ROAD_TEST_CHECKS}.transmissionClutchSubtitle`,
    content: [
      `${ROAD_TEST_CHECKS}.clutchOperatesProperly`,
      `${ROAD_TEST_CHECKS}.gaugesOperateProperly`,
      `${ROAD_TEST_CHECKS}.transmissionTransaxleShift`,
      `${ROAD_TEST_CHECKS}.transmissionTransaxleNoise`,
      `${ROAD_TEST_CHECKS}.4x4Operation`,
      `${ROAD_TEST_CHECKS}.driveAxleTransferCaseNoise`,
    ],
  },
  {
    label: `${ROAD_TEST_CHECKS}.majorCheckSubtitle`,
    content: [
      `${ROAD_TEST_CHECKS}.noMajorAccident`,
      `${ROAD_TEST_CHECKS}.noFireDamage`,
      `${ROAD_TEST_CHECKS}.noFloodDamage`,
    ],
  },
];
//     {
//       label: `${ROAD_TEST_CHECKS}.engine`,
//       content: [
//         `${ROAD_TEST_CHECKS}.engineStartsProperly`,
//         `${ROAD_TEST_CHECKS}.engineNoise`,
//         `${ROAD_TEST_CHECKS}.engineIdlesProperly`,
//         `${ROAD_TEST_CHECKS}.engineAcceleration`,
//         `${ROAD_TEST_CHECKS}.belting`,
//         `${ROAD_TEST_CHECKS}.engineTransmissionMounting`,
//       ],
//     },
//     {
//       label: `${ROAD_TEST_CHECKS}.steeringBrakesSuspension`,
//       content: [
//         `${ROAD_TEST_CHECKS}.brakePadsThickness`,
//         `${ROAD_TEST_CHECKS}.brakePedal`,
//         `${ROAD_TEST_CHECKS}.brakeLinesHosesFittings`,
//         `${ROAD_TEST_CHECKS}.suspensionAndShockAbsorber`,
//         `${ROAD_TEST_CHECKS}.steeringOperation`,
//         `${ROAD_TEST_CHECKS}.undercarriageNoises`,
//         `${ROAD_TEST_CHECKS}.gearBox`,
//       ],
//     },
//     {
//       label: `${ROAD_TEST_CHECKS}.transmissionClutch`,
//       content: [
//         `${ROAD_TEST_CHECKS}.clutchOperatesProperly`,
//         `${ROAD_TEST_CHECKS}.gaugesOperateProperly`,
//         `${ROAD_TEST_CHECKS}.transmissionTransaxleShift`,
//         `${ROAD_TEST_CHECKS}.transmissionTransaxleNoise`,
//         `${ROAD_TEST_CHECKS}.4x4Operation`,
//         `${ROAD_TEST_CHECKS}.driveAxleTransferCaseNoise`,
//       ],
//     },
//     {
//       label: `${ROAD_TEST_CHECKS}.majorCheck`,
//       content: [
//         `${ROAD_TEST_CHECKS}.noMajorAccident`,
//         `${ROAD_TEST_CHECKS}.noFireDamage`,
//         `${ROAD_TEST_CHECKS}.noFloodDamage`,
//       ],
//     },
//   ],
//   th: [
//     {
//       label: 'เครื่องยนต์',
//       content: [
//         'การสตาร์ทของเครื่องยนต์',
//         'เสียงผิดปกติในขณะเครื่องยนต์ทำงาน',
//         'การทำงานขณะรอบเดินเบา',
//         'อัตราเร่งของเครื่องยนต์',
//         'สายพานเครื่องยนต์',
//         'ยางแท่นเครื่องและเกียร์',
//       ],
//     },
//     {
//       label: 'ช่วงล่างและระบบกันสะเทือน',
//       content: [
//         'ความหนาของผ้าเบรค',
//         'แป้นเบรค',
//         'ระบบเบรค และ ท่อระบบเบรค',
//         'ระบบกันสะเทือนและโช๊ค',
//         'ระบบบังคับเลี้ยว',
//         'เสียงช่วงล่าง',
//         'ชุดเกียร์',
//       ],
//     },
//     {
//       label: 'ชุดคลัตช์และระบบส่งกำลัง',
//       content: [
//         'การทำงานของคลัตช์',
//         'ระบบเกจ์วัดและแผงหน้าปัด',
//         'การเปลี่ยนเกียร์สามารถทำงานได้อย่างปกติ',
//         'เสียงผิดปกติจากการทำงานของชุดเกียร์และระบบขับเคลื่อน',
//         'ระบบขับเคลื่อน 4 ล้อ',
//         'การทำงานของเพลาขับและชุดส่งกำลัง',
//       ],
//     },
//     {
//       label: 'การตรวจสภาพโดยรวม',
//       content: ['รถไม่มีอุบัติเหตุหนัก', 'รถไม่มีไฟไหม้', 'รถไม่มีรอยน้ำท่วม'],
//     },
//   ],
//   tw: [
//     {
//       label: '引擎',
//       content: ['引擎正常啟動', '引擎噪音', '引擎怠速', '引擎加速', '皮帶', '引擎腳'],
//     },
//     {
//       label: '方向盤＆煞車＆避震器',
//       content: ['煞車來令片厚度', '煞車踏板', '管線接頭', '避震器', '方向盤操作', '底盤噪音', '齒輪箱'],
//     },
//     {
//       label: '變速器＆離合器',
//       content: ['離合器正常運行', '儀表正常運行', '變速箱換檔', '變速箱異音', '四驅作動', '差速器 / 傳動箱異音'],
//     },
//     {
//       label: '重大事故檢驗',
//       content: ['無重大事故', '無火場損傷', '無泡水損傷'],
//     },
//   ],
//   my: [],
//   id: [],
//   jp: [
//     {
//       label: 'エンジン',
//       content: [
//         'エンジンが正常に始動する',
//         'エンジン音',
//         'エンジンのアイドリングが正常',
//         'エンジンの吹け上がり',
//         'タイミングベルト',
//         'エンジン＆トランスミッションのマウント',
//       ],
//     },
//     {
//       label: 'ステアリング & ブレーキ & サスペンション',
//       content: [
//         'ブレーキパッドの厚み',
//         'ブレーキペダル',
//         'ブレーキライン、ホース、フィッティング（継ぎ手）',
//         'サスペンション、ショックアブソーバー',
//         'ステアリング操作',
//         '足回りの異音',
//         'ギアボックス',
//       ],
//     },
//     {
//       label: 'トランスミッション＆クラッチ',
//       content: [
//         'クラッチが正常に作動するか',
//         'メーターが正常に作動するか',
//         'トランスミッション／トランスアクスルの変速',
//         'トランスミッション／トランスアクスルの異音',
//         '四輪駆動の動作',
//         'ドライブアクスル/トランスファーケースの異音',
//       ],
//     },
//     {
//       label: '主な確認事項',
//       content: ['修復歴なし', '火災被害なし', '水害なし'],
//     },
//   ],
// };

const EXTERIOR = `ccpo.inspectionPointList.exterior`;
const dataExterior: IPointContent[] = [
  {
    label: `${EXTERIOR}.bodyPanelBumperSubtitle`,
    content: [
      `${EXTERIOR}.doorSealAllDoors`,
      `${EXTERIOR}.doorHandles`,
      `${EXTERIOR}.frontBumper`,
      `${EXTERIOR}.frontFenderLeft`,
      `${EXTERIOR}.frontDoorsRight`,
      `${EXTERIOR}.frontDoorPanelRight`,
      `${EXTERIOR}.frontDoorsLeft`,
      `${EXTERIOR}.frontDoorPanelLeft`,
      `${EXTERIOR}.frontBonnetSupportAndInsulator`,
      `${EXTERIOR}.frontFenderRight`,
      `${EXTERIOR}.rearBonnet`,
      `${EXTERIOR}.rearFenderQuarterpanelRight`,
      `${EXTERIOR}.rearFenderQuarterpanelLeft`,
      `${EXTERIOR}.rearBumper`,
      `${EXTERIOR}.rearDoorsRight`,
      `${EXTERIOR}.rearDoorPanelRight`,
      `${EXTERIOR}.rearDoorsLeft`,
      `${EXTERIOR}.rearDoorPanelLeft`,
      `${EXTERIOR}.sideSkirtLeft`,
      `${EXTERIOR}.sideSkirtRight`,
      `${EXTERIOR}.bodyPanelInspection`,
    ],
  },
  {
    label: `${EXTERIOR}.hoodBootSubtitle`,
    content: [
      `${EXTERIOR}.grilleInspection`,
      `${EXTERIOR}.sunroofMoonroof`,
      `${EXTERIOR}.convertibleTop`,
      `${EXTERIOR}.frontBonnetRelease`,
    ],
  },
  {
    label: `${EXTERIOR}.glassMirrorSubtitle`,
    content: [
      `${EXTERIOR}.frontWindscreen`,
      `${EXTERIOR}.rearWindscreen`,
      `${EXTERIOR}.frontWindowLeft`,
      `${EXTERIOR}.frontWindowRight`,
      `${EXTERIOR}.rearWindowLeft`,
      `${EXTERIOR}.rearWindowRight`,
      `${EXTERIOR}.rearQuarterWindowLeft`,
      `${EXTERIOR}.rearQuarterWindowRight`,
      `${EXTERIOR}.rearWindowWiperWitch`,
      `${EXTERIOR}.windscreenWipersSwitch`,
      `${EXTERIOR}.wiperBladesFrontRear`,
      `${EXTERIOR}.powerWindowControls`,
      `${EXTERIOR}.leftSideMirror`,
      `${EXTERIOR}.rightSideMirror`,
      `${EXTERIOR}.outsideRearViewMirrors`,
      `${EXTERIOR}.sunVisorsVanityMirrorLight`,
    ],
  },
  {
    label: `${EXTERIOR}.exteriorLightsSubtitle`,
    content: [
      `${EXTERIOR}.frontEndExteriorLightsLeftHeadlight`,
      `${EXTERIOR}.frontEndExteriorLightsRightHeadlight`,
      `${EXTERIOR}.sideExteriorLights`,
      `${EXTERIOR}.rearEndExteriorLightsLeft`,
      `${EXTERIOR}.rearEndExteriorLightsRight`,
      `${EXTERIOR}.hazardLights`,
      `${EXTERIOR}.indicatorLight`,
      `${EXTERIOR}.fogLampFunction`,
      `${EXTERIOR}.daytimeRunningLight`,
      `${EXTERIOR}.lowHighBeamFunction`,
      `${EXTERIOR}.autoOnOffLights`,
    ],
  },
  {
    label: `${EXTERIOR}.rimWheelsSubtitle`,
    content: [
      `${EXTERIOR}.spareTyre`,
      `${EXTERIOR}.jackToolKit`,
      `${EXTERIOR}.rims`,
      `${EXTERIOR}.wheelAlignment`,
      `${EXTERIOR}.wheelCoversCenterCaps`,
    ],
  },
];

const INTERIOR = `ccpo.inspectionPointList.interior`;
const dataInterior: IPointContent[] = [
  {
    label: `${INTERIOR}.audioAlarmSystemSubtitle`,
    content: [
      `${INTERIOR}.radioCassetteCdDvdPlayer`,
      `${INTERIOR}.speakers`,
      `${INTERIOR}.alarmTheftDeterrentSystem`,
      `${INTERIOR}.reverseCamera`,
      `${INTERIOR}.antenna`,
    ],
  },
  {
    label: `${INTERIOR}.heatVentACDefogDefrostSubtitle`,
    content: [
      `${INTERIOR}.airConditioningSwitchPanel`,
      `${INTERIOR}.airConditioningParts`,
      `${INTERIOR}.airConditioningSystem`,
      `${INTERIOR}.frontAirconVents`,
      `${INTERIOR}.rearAirconVents`,
      `${INTERIOR}.antiFogDefrosterCoilDamage`,
      `${INTERIOR}.centerArmrestConsole`,
    ],
  },
  {
    label: `${INTERIOR}.carpetTrimMatSubtitle`,
    content: [
      `${INTERIOR}.floorMats`,
      `${INTERIOR}.interiorCarpet`,
      `${INTERIOR}.frontDoorTrimBoardRight`,
      `${INTERIOR}.frontDoorTrimBoardLeft`,
      `${INTERIOR}.doorTrimBoard2ndRowRight`,
      `${INTERIOR}.doorTrimBoard2ndRowLeft`,
      `${INTERIOR}.aPillarDoorTrimBoardRight`,
      `${INTERIOR}.aPillarDoorTrimBoardLeft`,
      `${INTERIOR}.bPillarDoorTrimBoardRight`,
      `${INTERIOR}.bPillarDoorTrimBoardLeft`,
      `${INTERIOR}.cPillarDoorTrimBoardRight`,
      `${INTERIOR}.cPillarDoorTrimBoardLeft`,
      `${INTERIOR}.gloveBox`,
      `${INTERIOR}.dashboardDrawer`,
      `${INTERIOR}.frontSeatIncludingElectricSeat`,
      `${INTERIOR}.rearSeatIncludingElectricSeat`,
      `${INTERIOR}.foldingSeats`,
      `${INTERIOR}.hotWarmedSeats`,
      `${INTERIOR}.cooledSeats`,
      `${INTERIOR}.seatHeadrestRestraintAdjustment`,
      `${INTERIOR}.headlining`,
      `${INTERIOR}.parcelShelfSpeakerBoardTonneauCover`,
    ],
  },
  {
    label: `${INTERIOR}.interiorAmenitiesSubtitle`,
    content: [
      `${INTERIOR}.clock`,
      `${INTERIOR}.powerOutlet12VPortCigaretteLighter`,
      `${INTERIOR}.powerOutletUSBPortCigaretteLighter`,
      `${INTERIOR}.powerSteering`,
      `${INTERIOR}.steeringWheelControls`,
      `${INTERIOR}.steeringWheelCondition`,
      `${INTERIOR}.tiltTelescopicSteeringWheel`,
      `${INTERIOR}.tripmeterAndOdometer`,
      `${INTERIOR}.interiorCourtesyDomeMapLights`,
      `${INTERIOR}.ashtrays`,
      `${INTERIOR}.handbrakeFootbrakeLever`,
      `${INTERIOR}.gearKnob`,
      `${INTERIOR}.horn`,
      `${INTERIOR}.warningLight`,
      `${INTERIOR}.cruiseControlOperation`,
      `${INTERIOR}.driverProfileMemorySystem`,
      `${INTERIOR}.dashboardControlPanel`,
      `${INTERIOR}.paddleShifters`,
    ],
  },
  {
    label: `${INTERIOR}.safetySubtitle`,
    content: [`${INTERIOR}.safetyBelts`, `${INTERIOR}.airbags`],
  },
  {
    label: `${INTERIOR}.lockEntrySubtitle`,
    content: [
      `${INTERIOR}.centralLockingSystem`,
      `${INTERIOR}.remoteBootRelease`,
      `${INTERIOR}.pushStartButtonSystem`,
      `${INTERIOR}.fuelCapRelease`,
    ],
  },
  {
    label: `${INTERIOR}.luggageCompartmentSubtitle`,
    content: [
      `${INTERIOR}.luggageCompartmentLight`,
      `${INTERIOR}.luggageCompartmentTrimCargoNet`,
      `${INTERIOR}.luggageBoard`,
    ],
  },
];

const UNDER_BODY_AND_HOOD = `ccpo.inspectionPointList.underBodyAndHood`;
const dataUnderbody: IPointContent[] = [
  {
    label: `${UNDER_BODY_AND_HOOD}.fluidsSubtitle`,
    content: [
      `${UNDER_BODY_AND_HOOD}.brakeFluid`,
      `${UNDER_BODY_AND_HOOD}.transmissionFluid`,
      `${UNDER_BODY_AND_HOOD}.transmissionFluidLeaks`,
      `${UNDER_BODY_AND_HOOD}.powerSteeringFluid`,
      `${UNDER_BODY_AND_HOOD}.windshieldWasherFluids`,
      `${UNDER_BODY_AND_HOOD}.engineOil`,
      `${UNDER_BODY_AND_HOOD}.engineOilLeaks`,
    ],
  },
  {
    label: `${UNDER_BODY_AND_HOOD}.coolantSubtitle`,
    content: [
      `${UNDER_BODY_AND_HOOD}.coolantTank`,
      `${UNDER_BODY_AND_HOOD}.coolant`,
      `${UNDER_BODY_AND_HOOD}.radiator`,
    ],
  },
  {
    label: `${UNDER_BODY_AND_HOOD}.electricalSystemSubtitle`,
    content: [`${UNDER_BODY_AND_HOOD}.wiring`, `${UNDER_BODY_AND_HOOD}.engineCover`, `${UNDER_BODY_AND_HOOD}.battery`],
  },
  {
    label: `${UNDER_BODY_AND_HOOD}.exhaustSystemSubtitle`,
    content: [`${UNDER_BODY_AND_HOOD}.exhaustSystem`],
  },
  {
    label: `${UNDER_BODY_AND_HOOD}.underbodySubtitle`,
    content: [
      `${UNDER_BODY_AND_HOOD}.powerSteeringPump`,
      `${UNDER_BODY_AND_HOOD}.rackPinionLinkageBoots`,
      `${UNDER_BODY_AND_HOOD}.tieRodsIdlerArm`,
      `${UNDER_BODY_AND_HOOD}.controlArmsBallJoints`,
      `${UNDER_BODY_AND_HOOD}.swayBarsLinksBushings`,
    ],
  },
  {
    label: `${UNDER_BODY_AND_HOOD}.tyreSubtitle`,
    content: [
      `${UNDER_BODY_AND_HOOD}.frontTyreLeft`,
      `${UNDER_BODY_AND_HOOD}.frontTyreRight`,
      `${UNDER_BODY_AND_HOOD}.RearTyreLeft`,
      `${UNDER_BODY_AND_HOOD}.rearTyreRight`,
    ],
  },
];
// eslint-disable-next-line import/prefer-default-export
export const getDataByCountry = () => {
  const data: Record<KeyPoint, IPointContent[]> = {
    roadTestChecks: dataRoadTestChecks,
    exterior: dataExterior,
    interior: dataInterior,
    underbody: dataUnderbody,
  };

  return data;
};
